import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

/**
 * Fetches a single uploaded document as a blob and returns an object URL.
 * GET api/BulkUpload/view-onboarding-document?documentId={id}
 *
 * @returns {{ success: boolean, url?: string, contentType?: string, message?: string }}
 */
export const viewOnboardingDocumentAction = async (documentId) => {
  try {
    const response = await apiClient.get(
      `${ATP_API_URL.VIEW_ONBOARDING_DOCUMENT}?documentId=${documentId}`,
      { responseType: "blob" },
    );

    if (response?.status === 200 && response.data) {
      const contentType =
        response.headers?.["content-type"] || "application/octet-stream";
      const blob = new Blob([response.data], { type: contentType });
      const url = URL.createObjectURL(blob);
      return { success: true, url, contentType };
    }
    return { success: false, message: "Failed to load document" };
  } catch (error) {
    console.error("[ViewOnboardingDocument] error:", error);
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.message ||
        "Failed to load document",
    };
  }
};
